// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment talk-to-sales-upsells --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useTalkToSalesUpsellsVariation = makeBooleanFlagValueHook('talk-to-sales-upsells');
//# sourceMappingURL=useTalkToSalesUpsellsVariation.js.map